/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Information_DetailsInputs */



/**
* | output |
* | --- |
* | "Project information details" |
*
* @param {Project_Information_DetailsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_information_details = /** @type {((inputs?: Project_Information_DetailsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Information_DetailsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Détails des informations du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektinformationen Details")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dettagli delle informazioni sul progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подробная информация о проекте")
	if (locale === "es") return /** @type {LocalizedString} */ ("Detalles de la información del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目信息详情")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクト情報の詳細")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परियोजना संबंधी जानकारी का विवरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Detalhes das informações do projeto")
	return /** @type {LocalizedString} */ ("Project information details")
});